module.exports = __webpack_public_path__ + "img/02-1.a6efd341.png";